import { render, staticRenderFns } from "./rkMessVerification.vue?vue&type=template&id=bb5bf212&scoped=true&"
import script from "./rkMessVerification.vue?vue&type=script&lang=js&"
export * from "./rkMessVerification.vue?vue&type=script&lang=js&"
import style0 from "./rkMessVerification.vue?vue&type=style&index=0&id=bb5bf212&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5bf212",
  null
  
)

export default component.exports